import type { FC } from "react";
import * as Styled from "./style";
import { useWelcomePageUrl } from "~/hooks/use-welcome-page-url";

type Props = {
  isLimitedPremium: boolean;
  isPremiumMemberBefore: boolean;
};

export const Banner: FC<Props> = (props: Props) => {
  const { isLimitedPremium, isPremiumMemberBefore } = props;
  const welcomePageUrl = useWelcomePageUrl();
  const buttonText = isPremiumMemberBefore ? "DMMプレミアム入会" : "30日間無料トライアル";

  return (
    <Styled.DivContainer role="region" aria-label="入会案内バナー">
      <Styled.DivActionButtonWrapper>
        {/* icon */}
        <Styled.DivIconWrapper>
          <Styled.Icon name="dmmTv" />
        </Styled.DivIconWrapper>

        {/* description */}
        <Styled.DivSummaryWrapper>
          {isLimitedPremium ? (
            <Styled.ParSummary>DMMプレミアム会員ならこの作品をお得に購入できる！</Styled.ParSummary>
          ) : (
            <Styled.ParSummary>月額550円でアニメ・エンタメ 見切れないほど、見放題！</Styled.ParSummary>
          )}
          <Styled.ParSubSummary>
            新作アニメに加えてDMM TVでしか観られない独占・オリジナル作品も見放題！
          </Styled.ParSubSummary>

          {/* SP */}
          <Styled.ParSummaryWrapper>
            {isLimitedPremium ? (
              <>
                <Styled.SpanSPSummary>DMMプレミアム会員なら</Styled.SpanSPSummary>
                <Styled.SpanSPSummary>この作品をお得に購入できる！</Styled.SpanSPSummary>
              </>
            ) : (
              <>
                <Styled.SpanSPSummary>月額550円でアニメ・エンタメ</Styled.SpanSPSummary>
                <Styled.SpanSPSummary>見切れないほど、見放題！</Styled.SpanSPSummary>
              </>
            )}
          </Styled.ParSummaryWrapper>

          <Styled.ParSummaryWrapper marginTop={4}>
            <Styled.SpanSPSubSummary>新作アニメに加えてDMM TVでしか観られない</Styled.SpanSPSubSummary>
            <Styled.SpanSPSubSummary>独占・オリジナル作品も見放題！</Styled.SpanSPSubSummary>
          </Styled.ParSummaryWrapper>
        </Styled.DivSummaryWrapper>

        {/* button */}
        <Styled.AnchorPurchase href={welcomePageUrl}>{buttonText}</Styled.AnchorPurchase>
      </Styled.DivActionButtonWrapper>
    </Styled.DivContainer>
  );
};
